import { getWeekdays } from '~/utils/helpers';

export const getNextDayOfWeek = (weekday: string): string => {
  const weekdays = getWeekdays();
  return weekdays[(weekdays.indexOf(weekday) + 1) % weekdays.length];
};
